import { render, staticRenderFns } from "./CreateTemplateView.vue?vue&type=template&id=6fe42f7a"
import script from "./CreateTemplateView.vue?vue&type=script&lang=js"
export * from "./CreateTemplateView.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateView.vue?vue&type=style&index=0&id=6fe42f7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports